import { c as _c } from "react/compiler-runtime";
// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/light/5.svg: path and width byte-identical (components/icons, Phase 5).
export default function Light5Icon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M48.5 44.1C50.3 37 56.7 32 64 32l208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L76.5 64l-40 160L192 224c70.7 0 128 57.3 128 128s-57.3 128-128 128L84.5 480c-33.3 0-63.8-18.8-78.7-48.6l-4.1-8.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.1 8.2c9.5 19 28.9 31 50.1 31L192 448c53 0 96-43 96-96s-43-96-96-96L16 256c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l48-192z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden="true" className={className} data-page-icon="light/5" fill="currentColor" focusable="false" height="1em" overflow="visible" viewBox="0 0 320 512" width="0.625em">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}